/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum WorkLogStatus {
  Pending = 'PENDING',
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}
